import { NgModule } from '@angular/core';
import { MaterialSharedModule } from './material-shared.module';
import { ThirdSharedModule } from './third-shared.module';
import { FuseSharedModule } from '@fuse/shared.module';


@NgModule({
    imports: [
        FuseSharedModule,
        MaterialSharedModule,
        ThirdSharedModule,
    ],
    exports: [
        FuseSharedModule,
        MaterialSharedModule,
        ThirdSharedModule,
    ]
})
export class SharedModule { }
